<template>
  <v-card>
    <v-card-title>
      <v-spacer></v-spacer>
      <v-btn
        v-if="
          deleteAllowed &&
          (!isTransferApplication || transferData.data.RequestStatus === 0)
        "
        @click.stop="confirmDeleteTransfer"
        class="mr-2"
        color="error"
      >
        <v-icon>mdi-delete</v-icon>
        Eliminar
      </v-btn>
      <v-btn @click.stop="closeModal" color="red" icon>
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text class="px-3">
      <!-- transfer header -->
      <v-card color="comment" rounded="lg" dark>
        <v-card-text class="text-h6 text-center">
          <v-row>
            <v-col v-if="!isTransferApplication" cols="12" md="3">
              <span class="font-weight-bold">ID Transferencia: </span>
              <span>{{ transferData.data.ID_Transfer }}</span>
            </v-col>
            <v-col v-else cols="12" md="3">
              <span class="font-weight-bold">ID Solicitud: </span>
              <span>{{ transferData.data.ID_Request }}</span>
            </v-col>
            <v-col cols="12" md="3">
              <span class="font-weight-bold">Almacen Origen: </span>
              <div>{{ transferData.data.OriginWarehouse }}</div>
            </v-col>
            <v-col cols="12" md="3">
              <span class="font-weight-bold">Destino: </span>
              <div>{{ transferData.data.DestinyWarehouse }}</div>
            </v-col>
            <v-col cols="12" md="3">
              <span class="font-weight-bold">Usuario Solicita:</span>
              <div>{{ transferData.data.userName }}</div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-btn
        class="text-h6 my-3"
        @click.prevent="showNotes = !showNotes"
        :color="transferData.data.Comments ? 'warning' : 'comment'"
        block
        dark
      >
        <v-icon class="icon-color">mdi-comment</v-icon>
        Comentarios
      </v-btn>

      <div
        class="d-flex flex-wrap justify-center justify-sm-space-between align-center"
      >
        <div class="d-flex">
          <!-- button make transfer / accept received -->
          <v-btn
            v-if="
              isTransferApplication &&
              (checkTransferStatus || (transferData.data.RequestStatus === 3 && !transferData.data.DateTransfer)) &&
              $store.getters['rolesUser/getCustomRole'](117)
            "
            color="primary"
            class="mr-2"
            @click.stop="showAddProducts()"
          >
            <v-icon class="mr-0">mdi-archive-plus</v-icon>
            {{ transferData.data.RequestStatus === 3 ? 'Aceptar recibido' : 'Hacer traspaso' }}
          </v-btn>
          <!-- button send transfer -->
          <v-btn
            v-if="
              isTransferApplication &&
              (transferData.data.RequestStatus === 0 || transferData.data.RequestStatus === 2) &&
              $store.getters['rolesUser/getCustomRole'](117)
            "
            color="primary"
            class="mr-2"
            @click.stop="sendTransferRequest()"
          >
            <v-icon class="mr-0">mdi-truck-delivery</v-icon>Enviar productos
          </v-btn>
          <!-- button export PDF file -->
          <v-btn color="primary" @click="exportPdf">
            <v-icon>mdi-file-pdf-box</v-icon>
            Exportar PDF
          </v-btn>
        </div>
        <!-- dates for request transfer -->
        <div v-if="isTransferApplication" class="d-flex">
          <div class="text-center mr-5">
            <div class="text-caption font-weight-bold">Fecha Solicitud</div>
            <div>{{ transferData.data.RequestDate }}</div>
          </div>
          <div class="text-center">
            <div class="text-caption font-weight-bold">Fecha Aprobación</div>
            <div>
              {{
                transferData.data.DateTransfer
                  ? transferData.data.DateTransfer
                  : ""
              }}
            </div>
          </div>
        </div>
        <!-- dates for normal transfers -->
        <div v-else>
          <div class="text-center">
            <div class="text-caption font-weight-bold">Fecha Aprobación</div>
            <div>{{ transferData.data.TransferDate }}</div>
          </div>
        </div>
      </div>

      <!-- Tabla -->
      <GeneralFilter
        class="background border-box"
        entity="transferencia"
        :filterEndpoint="filterTransferProduct"
        :search="search"
        @emptyFilter="getProductsToShow"
        @filtered="filterHandler"
      >
        <DxDataGrid
          ref="dxDataGridDetails"
          :data-source="transferData.data.details"
          key="ID_Transfer"
          :show-row-line="ShowRowLines"
          :show-border="showBorders"
          :row-alternation-enabled="rowAlternationEnabled"
          @exporting="onExporting"
          :scrolling="{ useNative: true }"
          width="100%"
        >
          <DxExport :enabled="true" />
          <DxPaging :page-size="10" />
          <DxColumn
            data-field="ID_Item"
            caption="ID Producto"
            :width="columnWidth"
          ></DxColumn>
          <DxColumn
            data-field="ItemBarCode"
            caption="Código alterno"
            :width="columnWidth"
          ></DxColumn>
          <DxColumn
            data-field="ItemName"
            caption="Nombre"
            :width="columnWidth"
          ></DxColumn>
          <DxColumn
            data-field="CantidadSolicitada"
            caption="Cantidad Solicitada"
            :width="columnWidth"
            :customize-text="formatStockValue"
          ></DxColumn>
          <DxColumn
            data-field="CostoPromedio"
            caption="Costo Promedio"
            :width="columnWidth"
            data-type="number"
            format="$#,##0.00##"
          ></DxColumn>
          <DxColumn
            :calculate-cell-value="calculateStockOrigin"
            caption="Nueva existencia (Origen)"
            :width="columnWidth"
            :customize-text="formatStockValue"
          ></DxColumn>
          <DxColumn
            data-field="StockDestinoResultante"
            caption="Nueva existencia (Destino)"
            :width="columnWidth"
            :customize-text="formatStockValue"
          ></DxColumn>
        </DxDataGrid>
      </GeneralFilter>

      <!-- Tabla -->
    </v-card-text>

    <!-- comment dialog -->
    <v-dialog width="80%" v-model="showNotes">
      <v-card class="pa-4">
        <div
          style="
            margin-top: 0.3rem;
            margin-bottom: 0.3rem;
            display: flex;
            justify-content: flex-end;
          "
        >
          <v-btn small class="btndelete" @click.prevent="showNotes = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <!-- <quill-editor :content="form.notes" :options="quillOptions"></quill-editor> -->
        <quill-editor
          :content="transferData.data.Comments"
          :options="quillOptions"
          disabled
        ></quill-editor>
      </v-card>
    </v-dialog>

    <!-- alert -->

    <alert
      v-model="alert.show"
      :type="alert.type"
      :title="alert.title"
      :message="alert.message"
    >
    </alert>

    <!-- delete alert -->
    <alert
      v-model="alertDelete.show"
      type="confirm-danger"
      :title="`Eliminar ${
        isTransferApplication ? 'Solicitud de transferencia' : 'Transferencia'
      }`"
      :message="`¿Desea eliminar la transferencia ${
        transferData.data.ID_Request || transferData.data.ID_Transfer
      }?`"
      btn-ok-text="Eliminar"
      @action="
        isTransferApplication ? deleteTransferRequest() : deleteTransfer()
      "
    >
    </alert>

    <!-- loading screen -->
    <block v-model="loading"></block>
  </v-card>
</template>

<script>
import {
  DxDataGrid,
  DxExport,
  DxColumn,
  DxPaging,
} from "devextreme-vue/data-grid";
import { printToExcel } from "../../helpers/printToexcel";
import { quillConfig } from "../../helpers/quillconfig";
import { mapState, mapMutations } from "vuex";
import GeneralFilter from "@/components/GeneralFilter.vue";
import { addFormatToNIT, addFormatNRC } from "../../helpers/misc";

export default {
  name: "TransferDetails",
  data: () => ({
    ShowRowLines: true,
    showBorders: true,
    rowAlternationEnabled: true,
    showNotes: false,
    quillOptions: quillConfig,
    alert: {
      type: "success",
      show: false,
      header: "",
      body: "",
    },
    alertDelete: {
      show: false,
      title: "",
      message: "",
    },
    hover: false,
    search: {
      filter: null,
    },
    loading: false,
  }),
  components: {
    DxDataGrid,
    DxPaging,
    DxColumn,
    DxExport,
    GeneralFilter,
  },

  props: {
    transferData: {
      type: Object,
    },
    isTransferApplication: {
      type: Boolean,
      default: false,
    },
    deleteAllowed: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.getExtraInfoTransfer().then(() => {
      this.saveTransferData();
    });
  },

  computed: {
    columnWidth() {
      return this.$vuetify.breakpoint.smAndDown ? "150px" : "auto !important";
    },
    checkTransferStatus() {
      // Status of the order
      // Pendiente == 0
      // Realizado == 1
      // No disponible == 2
      return (
        this.transferData.data.RequestStatus == 0 ||
        this.transferData.data.RequestStatus == 2
      );
    },
    ...mapState("rolesUser", {
      rolesStatus: (state) => state.roles,
    }),
    isCarsem(){
      return JSON.parse(localStorage.getItem('user'))?.keymaster == 'f33722a12f5e692b30374bbcf86011db';
    }
  },

  methods: {
    ...mapMutations({
      setReload: "transferData/setReload",
    }),
    // Función para convertir HTML a texto plano
    htmlToPlainText(html) {
      if (!html) return "";

      // Crear un elemento temporal para decodificar el HTML
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = html;

      // Obtener solo el texto, sin etiquetas HTML
      let plainText = tempDiv.textContent || tempDiv.innerText || "";

      // Limpiar espacios en blanco excesivos y saltos de línea
      plainText = plainText.replace(/\s+/g, " ").trim();

      return plainText;
    },
    onExporting(e) {
      const title = this.isTransferApplication
        ? "Solicitud de transferencia de inventario"
        : "Transferencia de inventario";
      const id = this.isTransferApplication
        ? this.transferData.data.ID_Request
        : this.transferData.data.ID_Transfer;
      printToExcel(e, `Productos de ${title} ID ${id}`);
    },
    async exportPdf() {
      this.loading = true;
      try {
        // Obtener datos de sucursal y negocio
        let branch = JSON.parse(localStorage.getItem("user")).branch;
        let business = JSON.parse(localStorage.getItem("user")).businessid;
        let [businessInfo] = await this.$API.branches.findSpecificBranch({
          branch,
          business,
        });

        let logoUrl = businessInfo.BusinessLogoPath;
        let logoImg = null;
        if (logoUrl) {
          try {
            const { imageBase64 } = await this.$API.utilities.getImageInBase64({
              file: logoUrl,
            });
            logoImg = imageBase64;
          } catch (e) {
            logoImg = null;
            console.warn("No se pudo cargar el logo en base64:", e.message);
          }
        }

        // Crear PDF
        const jsPDF =
          (await import("jspdf")).jsPDF || (await import("jspdf")).default;
        const autoTable = (await import("jspdf-autotable")).default;
        const doc = new jsPDF("p", "mm", "a4");
        const pageWidth = doc.internal.pageSize.getWidth();
        let y = 12;

        // Logo y datos empresa
        if (logoImg) {
          doc.addImage(logoImg, "PNG", 10, 8, 38, 18);
        }
        // let xRight = pageWidth - 2;
        doc.setFontSize(10);
        doc.setFont(undefined, "bold");
        doc.text(businessInfo?.BusinessName || "", 12, 30);
        doc.setFont(undefined, "normal");
        let yInfo = 35;
        const data = this.transferData.data;
        const isSolicitud = this.isTransferApplication;
        doc.setFontSize(10);
        doc.setFont(undefined, "bold");
        doc.text(
          "Fecha de impresión: " + new Date().toLocaleDateString(),
          pageWidth - 12,
          15,
          { align: "right" }
        );
        doc.text(
          isSolicitud
            ? "ID Solicitud: " + data.ID_Request
            : "ID Transferencia: " + data.ID_Transfer,
          pageWidth - 12,
          21,
          { align: "right" }
        );
        doc.setLineWidth(0.3);
        doc.line(10, yInfo + 2, pageWidth - 10, yInfo + 2);
        y = yInfo + 8;

        // Encabezado de transferencia
        doc.setFontSize(13);
        doc.setFont(undefined, "bold");
        doc.text("Transferencia de Inventario", pageWidth / 2, y, {
          align: "center",
        });
        y += 8;
        doc.setFontSize(10);
        doc.setFont(undefined, "normal"); // Construir array de encabezado con fechas dinámicas
        const encabezado = [
          `Almacén Origen: ${data.OriginWarehouse}`,
          `Destino: ${data.DestinyWarehouse}`,
        ];

        // Agregar usuario que solicita (ReqName)
        if (data.ReqName) {
          encabezado.push(`Usuario Solicita: ${data.ReqName}`);
        }

        // Agregar usuario que aprueba (userName)
        if (data.userName) {
          encabezado.push(`Usuario Aprobación: ${data.userName}`);
        }

        // Agregar fechas según disponibilidad
        if (isSolicitud && data.RequestDate) {
          encabezado.push(`Fecha Solicitud: ${data.RequestDate}`);
        }
        if (data.DateTransfer) {
          encabezado.push(`Fecha Aprobación: ${data.DateTransfer}`);
        } else if (!isSolicitud && data.TransferDate) {
          encabezado.push(`Fecha Aprobación: ${data.TransferDate}`);
        }

        // Agregar encabezado básico
        encabezado.forEach((line) => {
          doc.text(line, 12, y);
          y += 6;
        });

        // Agregar comentarios si existen, manejando texto largo
        if (data.Comments) {
          const plainTextComments = this.htmlToPlainText(data.Comments);
          if (plainTextComments) {
            const maxWidth = pageWidth - 24; // Margen de 12px a cada lado
            const lines = doc.splitTextToSize(
              `Comentarios: ${plainTextComments}`,
              maxWidth
            );
            lines.forEach((line) => {
              doc.text(line, 12, y);
              y += 6;
            });
          }
        }
        y += 2;
        // Tabla de productos
        const detalles = data.details || [];
        
        let tableColumns = [
          { header: "ID Producto", dataKey: "ID_Item" },
          { header: "Código alterno", dataKey: "ItemBarCode" },
          { header: "Nombre", dataKey: "ItemName" },
          { header: "Cantidad Solicitada", dataKey: "CantidadSolicitada" },
          { header: "Costo Promedio", dataKey: "CostoPromedio" },
          {
            header: "Nueva existencia (Origen)",
            dataKey: "ItemCurrentQuantityOrigin",
          },
          {
            header: "Nueva existencia (Destino)",
            dataKey: "StockDestinoResultante",
          },
          { header: "Total", dataKey: "TotalPrecioPromedio" },
        ];
        if (this.isCarsem) {
          tableColumns = [
            { header: "ID Producto", dataKey: "ID_Item" },
            { header: "Código alterno", dataKey: "ItemBarCode" },
            { header: "Nombre", dataKey: "ItemName" },
            { header: "Cantidad Solicitada", dataKey: "CantidadSolicitada" },
            { header: "Nueva existencia (Origen)", dataKey: "ItemCurrentQuantityOrigin" },
            { header: "Nueva existencia (Destino)", dataKey: "StockDestinoResultante" },
          ];
        }
        const rows = detalles.map((item) => {
          const cantidad = parseFloat(item.CantidadSolicitada || 0);
          const costoPromedio = parseFloat(item.CostoPromedio || 0);
          const totalPrecioPromedio = cantidad * costoPromedio;
          
          return {
            ID_Item: item.ID_Item,
            ItemBarCode: item.ItemBarCode || "",
            ItemName: item.ItemName,
            CantidadSolicitada: item.CantidadSolicitada,
            CostoPromedio: `$${costoPromedio.toFixed(2)}`,
            TotalPrecioPromedio: `$${totalPrecioPromedio.toFixed(2)}`,
            ItemCurrentQuantityOrigin: item.StockOrigenResultante ?? 0,
            StockDestinoResultante: item.StockDestinoResultante ?? 0,
          };
        });

        // Calcular totales
        const totalCantidad = detalles.reduce((sum, item) => sum + parseFloat(item.CantidadSolicitada || 0), 0);
        //const totalCosto = detalles.reduce((sum, item) => sum + parseFloat(item.CostoPromedio || 0), 0);
        const totalPrecioProm = detalles.reduce((sum, item) => {
          const cantidad = parseFloat(item.CantidadSolicitada || 0);
          const costoPromedio = parseFloat(item.CostoPromedio || 0);
          return sum + (cantidad * costoPromedio);
        }, 0);
        //const totalExistenciaOrigen = detalles.reduce((sum, item) => sum + parseFloat(item.StockOrigenResultante ?? 0), 0);
        //const totalExistenciaDestino = detalles.reduce((sum, item) => sum + parseFloat(item.StockDestinoResultante ?? 0), 0);

        autoTable(doc, {
          startY: y,
          head: [tableColumns.map((col) => col.header)],
          body: rows.map((row) => tableColumns.map((col) => row[col.dataKey])),
          styles: { fontSize: 9, cellPadding: 1.5 },
          headStyles: {
            fillColor: [128, 128, 128],
            textColor: 255,
            halign: "center",
          },
          bodyStyles: { valign: "top" },
          tableWidth: "auto",
          columnStyles: {
            0: { cellWidth: "auto", halign: "center" },
            1: { cellWidth: "auto", halign: "center" },
            2: { cellWidth: "auto", halign: "center" },
            3: { cellWidth: "auto", halign: "center" },
            4: { cellWidth: "auto", halign: "center" },
            5: { cellWidth: "auto", halign: "center" },
            6: { cellWidth: "auto", halign: "center" },
            7: { cellWidth: "auto", halign: "center" },
          },
          theme: "grid",
          foot: [
            [
              { content: "TOTAL:", colSpan: 3, styles: { halign: "right", fontStyle: "bold" } },
              { content: totalCantidad.toFixed(2), styles: { halign: "center", fontStyle: "bold" } },
              { content: ``, styles: { halign: "center", fontStyle: "bold" } },
              { content: '', styles: { halign: "center", fontStyle: "bold" } },
              { content: '', styles: { halign: "center", fontStyle: "bold" } },
              { content: `$${totalPrecioProm.toFixed(2)}`, styles: { halign: "center", fontStyle: "bold" } },
            ],
          ],
          footStyles: {
            fillColor: [240, 240, 240],
            textColor: 20,
            fontStyle: "bold",
            fontSize: 10,
          },
        });
        // Firmas
        doc.setFontSize(10);

        // Paginación
        const pageCount = doc.internal.getNumberOfPages();
        for (let i = 1; i <= pageCount; i++) {
          doc.setPage(i);
          doc.setFontSize(8);
          doc.text(
            `Página ${i} de ${pageCount}`,
            pageWidth - 20,
            doc.internal.pageSize.getHeight() - 8,
            { align: "right" }
          );
        }

        // doc.save(`${isSolicitud ? data.ID_Request : data.ID_Transfer || 'Transferencia'}.pdf`);
        window.open(doc.output("bloburl"), "_blank");
      } catch (error) {
        this.showError("Error", "No se pudo exportar el PDF: " + error.message);
      } finally {
        this.loading = false;
      }
    },
    showAddProducts() {
      /*if (this.searchForNonStockOnDetails()) {
        this.setTransferStatus(
          this.transferData.data.details,
          this.transferData.data.RequestStatus,
          this.transferData.data.ID_Request
        );
        this.showError(
          "Error",
          "Uno o mas elementos de esta solictud no tiene el Stock suficiente para realizar el traspaso"
        );
        return;
      }*/
      this.$store.dispatch("resetWindow").then(() => {
        this.$store.dispatch("addWindow", {
          name: "AddTransfer",
          component: "AddTransfer",
          unique: true,
        });
      });
      this.setReload(true);
      this.sendDataToAddTransfer();
      this.reloadTable();
      this.closeModal();
    },
    closeModal() {
      this.$emit("close-modal", false);
    },
    reloadTable() {
      this.$emit("reload-table");
    },
    sendDataToAddTransfer() {
      this.transferData.data.tab = "request";
      this.$store.commit("transferData/setTransfers", this.transferData.data);
    },
    searchForNonStockOnDetails() {
      for (const element of this.transferData.data.details) {
        const { StockOrigenResultante } = element;
        if (StockOrigenResultante < 0) {
          return true;
        }
      }
      return false;
    },
    showAlert(title, message, type = "success") {
      this.alert.type = type;
      this.alert.title = title;
      this.alert.message = message;
      this.alert.show = true;
    },
    showError(title, message) {
      this.showAlert(title, message, "error");
    },
    closeAlert() {
      this.alert.show = false;
    },
    updateTransferStatus(data) {
      this.$API.inventoryTransfer
        .updateTransferStatusRequest(data)
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    setTransferStatus(details, requestStatus, ID_Request) {
      let RequestStatus = requestStatus;
      details.forEach((object) => {
        // 1 = Realizado
        if (requestStatus === 1) return;
        // 3 = Enviado
        if (requestStatus === 3) return;
        // 0 = Pendiente, 2 = No disponible
        if (requestStatus === 0 || requestStatus === 2) {
          if (object.StockOrigenResultante <= 0) {
            // 2 = No disponible
            RequestStatus = 2;
            this.setTransferStatusData(RequestStatus, ID_Request);
            return;
          }
          if (object.StockOrigenResultante >= 0) {
            // 0 = Pendiente
            RequestStatus = 0;
            this.setTransferStatusData(RequestStatus, ID_Request);
            return;
          }
        }
      });
      this.reloadTable();
      return RequestStatus;
    },
    setTransferStatusData(RequestStatus, ID_Request) {
      const transferStatusData = {
        ID_Request,
        RequestStatus,
      };

      this.updateTransferStatus(transferStatusData);
    },
    sendTransferRequest() {
      const transferStatusData = {
        ID_Request: this.transferData.data.ID_Request,
        RequestStatus: 3, // 3 = Enviado
      };

      this.updateTransferStatus(transferStatusData);
      this.transferData.data.RequestStatus = 3;
      this.reloadTable();
      this.$swal.fire({
        icon: 'success',
        title: 'Éxito',
        text: 'La solicitud ha sido marcada como enviada',
        confirmButtonText: 'Aceptar'
      });
    },
    filterTransferProduct({ filter, products }) {
      let filteredProducts = products.filter((product) => {
        // Obtener el código de barras de cualquiera de las dos ubicaciones posibles
        // const itemBarCode =
        //   product.ItemBarCode || product.inventory?.product?.ItemBarCode || "";

        return (
          product.ID_Item.toString().includes(filter) ||
          product.ItemName.includes(filter) ||
          product.CantidadSolicitada.toString().includes(filter) ||
          product.ItemBarCode?.toString().includes(filter)
        );
      });

      return new Promise((resolve) => {
        resolve(filteredProducts);
      });
    },
    saveTransferData() {
      const detailsWithBarCode = this.transferData.data.details.map(
        (element) => ({
          ...element,
          ItemBarCode:
            element.ItemBarCode ||
            element.inventory?.product?.ItemBarCode ||
            "",
        })
      );

      this.transferDataFilter = JSON.parse(JSON.stringify(detailsWithBarCode));
      this.search = {
        products: JSON.parse(JSON.stringify(detailsWithBarCode)),
      };
    },
    getProductsToShow() {
      this.transferData.data.details = JSON.parse(
        JSON.stringify(this.transferDataFilter)
      );
      // Re-ejecutar getExtraInfoTransfer para asignar ItemBarCode después de restaurar datos
      this.getExtraInfoTransfer();
    },
    async filterHandler(response) {
      this.transferData.data.details = response;
      // Asignar ItemBarCode a los elementos filtrados
      // for (let element of this.transferData.data.details) {
      //   if (!element.ItemBarCode) {
      //     element.ItemBarCode = element.inventory?.product?.ItemBarCode || "";
      //   }
      // }
      // Refrescar la tabla para mostrar los cambios
      this.$refs["dxDataGridDetails"].instance.refresh();
    },
    async getExtraInfoTransfer() {
      for (let element of this.transferData.data.details) {
        // Los valores de stock ya vienen correctamente de inventory_items_transfer_detail
        // Solo necesitamos asignar los nombres de almacenes
        element.WarehouseName = this.transferData.data.OriginWarehouse;
        element.warehouseAtDestination = this.transferData.data.DestinyWarehouse;
        
        // StockOrigenResultante y StockDestinoResultante ya vienen de la tabla
        // inventory_items_transfer_detail como NuevaExistenciaOrigen y NuevaExistenciaDestino
        // No necesitamos calcularlos ni consultar el stock actual
      }

      this.$refs["dxDataGridDetails"].instance.refresh();
    },
    calculateStockOrigin(data) {
      // Usar directamente el valor de StockOrigenResultante que viene de 
      // inventory_items_transfer_detail.NuevaExistenciaOrigen
      return data.StockOrigenResultante ?? 0;
    },
    formatStockValue(cellInfo) {
      // Formatear valores de existencias: si los decimales son .00, no mostrarlos
      const value = cellInfo.value ?? 0;
      const numValue = parseFloat(value);
      
      // Si el valor es entero (sin decimales significativos), mostrar sin decimales
      if (Number.isInteger(numValue) || numValue % 1 === 0) {
        return numValue.toString();
      }
      
      // Si tiene decimales, mostrarlos
      return numValue.toFixed(2);
    },
    calculateCellValue(data) {
      if (data.StockDestinoResultante) {
        return data.StockDestinoResultante;
      } else {
        return 0;
      }
    },
    getFormattedNIT(nit) {
      return nit ? addFormatToNIT(nit) : "";
    },
    getFormattedNRC(nrc) {
      return nrc ? addFormatNRC(nrc) : "";
    },
    confirmDeleteTransfer() {
      this.alertDelete.show = true;
    },
    async deleteTransfer() {
      try {
        this.alertDelete.show = false;
        this.loading = true;
        const { ID_Transfer } = this.transferData.data;
        const { data } = await this.$API.inventoryTransfer.deleteTransfer(
          ID_Transfer
        );
        this.showAlert("Información", data.message);

        this.reloadTable();
        this.closeModal();
      } catch (err) {
        const msg = this.$parseError(err);
        this.showError("Error", msg);
      } finally {
        this.loading = false;
      }
    },
    async deleteTransferRequest() {
      try {
        this.alertDelete.show = false;
        this.loading = true;
        const { ID_Request } = this.transferData.data;
        const { data } =
          await this.$API.inventoryTransfer.deleteTransferRequest(ID_Request);
        this.showAlert("Información", data.message);

        this.reloadTable();
        this.closeModal();
      } catch (err) {
        const msg = this.$parseError(err);
        this.showError("Error", msg);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
